import dayjs from "dayjs";
import React from "react";
import { Table } from "reactstrap";
const fm = new Intl.NumberFormat("es-MX", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const Columns = ({ filters }) => {
  const isOperatorReport = filters.report_type === "operator";

  let columns = [
    {
      id: "table",
      name: "",
      minWidth: "800px",
      cell: (e) => {
        return (
          <Table className="">
            <thead>
              <tr>
                {isOperatorReport ? <th width={"100px"}>Clave</th> : null}
                <th width={"200px"}>
                  {isOperatorReport ? "Operador" : "Número unidad"}
                </th>
                <th width={"100px"}>
                  {isOperatorReport ? "Unidad" : "Operador"}
                </th>
                <th width={"120px"}>Fecha</th>
                <th width={"100px"}>Días</th>
                <th width={"200px"}>Concesionario</th>
              </tr>
            </thead>
            <tbody>
              {e.salidas.length == 0 && (
                <tr>
                  {isOperatorReport ? <td>{e.key}</td> : null}
                  <td>{isOperatorReport ? e.full_name : e.number}</td>
                  <td></td>
                  <td></td>
                  <td>0</td>
                  <td></td>
                </tr>
              )}
              {e.asistencias.map((asistencias, ai) =>
                asistencias.map((s, si) => (
                  <tr key={si}>
                    {isOperatorReport ? (
                      <td>{ai == 0 && si == 0 ? e.key : ""}</td>
                    ) : null}
                    {isOperatorReport ? (
                      <td>{ai == 0 && si == 0 ? e.full_name : ""}</td>
                    ) : (
                      <td>{ai == 0 && si == 0 ? e.number : ""}</td>
                    )}

                    <td>{s[0]}</td>
                    <td>{s[1] == s[2] ? s[1] : s[1] + "-" + s[2]}</td>
                    <td>{s[3]}</td>
                    <td>{s[4]}</td>
                  </tr>
                ))
              )}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={3} className="text-end"></th>
                <th>{e.asistencias_total}</th>
                <th></th>
              </tr>
            </tfoot>
          </Table>
        );
      },
    },
  ];
  return columns;
};

export default Columns;

//vaneton beicli
